import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.api.ApiResponseHandler.';
  public static readonly clientSessionInvalid = `${Id.prefix}clientSessionInvalid`;
  public static readonly duplicateLogin = `${Id.prefix}duplicateLogin`;
  public static readonly systemOfflineMsg = `${Id.prefix}systemOfflineMsg`;
  public static readonly systemOfflineTitle = `${Id.prefix}systemOfflineTitle`;
  public static readonly serverErrorOccurred = `${Id.prefix}serverErrorOccurred`;
  public static readonly validationIssuesFromServer = `${Id.prefix}validationIssuesFromServer`;
  public static readonly serverBusyTitle = `${Id.prefix}serverBusyTitle`;
  public static readonly serverBusyMessage = `${Id.prefix}serverBusyMessage`;
  public static readonly retry = `${Id.prefix}retry`;
  public static readonly cancel = `${Id.prefix}cancel`;
}

export class LangApiResponseHandler {
  private constructor() {}
  public static clientSessionInvalid(): string {
    return interpolate(Id.clientSessionInvalid);
  }
  public static duplicateLogin(): string {
    return interpolate(Id.duplicateLogin);
  }
  public static systemOfflineMsg(): string {
    return interpolate(Id.systemOfflineMsg);
  }
  public static systemOfflineTitle(): string {
    return interpolate(Id.systemOfflineTitle);
  }
  public static serverErrorOccurred(): string {
    return interpolate(Id.serverErrorOccurred);
  }
  public static validationIssuesFromServer(): string {
    return interpolate(Id.validationIssuesFromServer);
  }
  public static serverBusyTitle(): string {
    return interpolate(Id.serverBusyTitle);
  }
  public static serverBusyMessage(): string {
    return interpolate(Id.serverBusyMessage);
  }
  public static retry(): string {
    return interpolate(Id.retry);
  }
  public static cancel(): string {
    return interpolate(Id.cancel);
  }
}

export class ApiResponseHandlerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.clientSessionInvalid,
      'Your client session is no longer valid. Refreshing Page to attempt recovery',
      'Message shown when client session is invalid and page will refresh'
    );
    register.add(
      Id.duplicateLogin,
      'You are being disconnected as your account is logged into another machine (or Browser)',
      'Message shown when duplicate login is detected'
    );
    register.add(
      Id.systemOfflineMsg,
      'Cannot communicate with the server. There may be a network outage. please check your internet and try again',
      'Message shown when system is offline'
    );
    register.add(Id.systemOfflineTitle, 'System OFFLINE', 'Title for system offline dialog');
    register.add(Id.serverErrorOccurred, 'Server Error Occurred', 'Message shown when a server error occurs');
    register.add(
      Id.validationIssuesFromServer,
      'Validation Issues from Server',
      'Message shown when validation errors are returned from the server'
    );
    register.add(Id.serverBusyTitle, 'Server Busy', 'Title for the server-busy retry prompt');
    register.add(
      Id.serverBusyMessage,
      'The server is currently very busy and could not complete your request. Please wait a moment and try again.',
      'Message shown when the server responds with a busy/retry signal'
    );
    register.add(Id.retry, 'Retry', 'Caption for the retry button on the server-busy prompt');
    register.add(Id.cancel, 'Cancel', 'Caption for the cancel button on the server-busy prompt');
  }
}
